<template>
  <div class="row blaStepFieldContainer" ref="list">
    <Loader :show="showLoader" />

    <div class="col-10 offset-1 col-md-8 offset-md-2">
      <div class="row align-content-center">
        <div class="col-12 col-md-8 offset-md-2">
          <div
            @click="$router.push({ name: 'chooser' })"
            class="blaStepFieldTitleButton text-center d-inline-block pr-1"
          >
            <i class="fas fa-angle-left"></i>
          </div>
          <div class="blaStepFieldTitle d-inline-block">Ranglista</div>
          <div class="blaStepFieldTitleAlt">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="d-inline">{{ currentWeek }}. heti verseny</div>
              </div>
              <div class="col-12 col-md-6">
                <div class="d-inline pull-md-right" id="timer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-10 offset-1 col-md-8 offset-md-2 mt-4">
      <div class="row align-content-center">
        <div class="col-12 col-md-8 offset-md-2 blaLeaderBoardBox">
          <div class="row">
            <!-- Title -->
            <div class="col-12 blaLeaderBoardTitle">
              <div class="row my-2">
                <div class="col-3 text-center">
                  <img
                    :src="require('@/assets/img/trophy.png')"
                    alt="trophy"
                    class="blaLeaderBoardIcon"
                  />
                </div>
                <div class="col-6">Ranglista</div>
                <div class="col-3 text-center text-md-right">
                  <div
                    @click="showInfoModal = true"
                    class="
                      blaStepFieldTitleButton
                      text-center
                      d-inline-block
                    "
                  >
                    <i class="fas fa-info-circle"></i>
                  </div>
                </div>
              </div>
            </div>
            <!-- List -->
            <div class="col-12">
              <!-- GOLD -->
              <div
                v-if="
                  leaderBoardDatas.datas &&
                  leaderBoardDatas.datas.gold &&
                  leaderBoardDatas.datas.gold.length != 0
                "
              >
                <div
                  v-for="(item, index) in leaderBoardDatas.datas.gold"
                  :key="'gold-' + index"
                  class="row blaLeaderBoardPlayerCard"
                  :class="{ blaLeaderBoardActive: item.isCurrentUser }"
                >
                  <div class="col-3 blaLeaderBoardPosition">
                    {{ item.position }} .
                  </div>
                  <div class="col-5 blaLeaderBoardNickname">
                    {{ item.nickname }}
                  </div>
                  <div class="col-4 blaLeaderBoardScores">
                    {{ item.score_weekly }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="blaLeaderBoardNoData">
                      Még senki sem érte el a GOLD zónát!
                    </div>
                  </div>
                </div>
              </div>
              <!-- GOLD - HR -->
              <div class="row w-100 blaLeaderBoardHR gold">
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
                <div class="col-8 blaLeaderBoardHRText">
                  GOLD ZÓNA <br />
                  100.000 lingron <br />
                  összegyűjtése után
                </div>
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
              </div>

              <!-- SILVER -->
              <div
                v-if="
                  leaderBoardDatas.datas &&
                  leaderBoardDatas.datas.silver &&
                  leaderBoardDatas.datas.silver.length != 0
                "
              >
                <div
                  v-for="(item, index) in leaderBoardDatas.datas.silver"
                  :key="'gold-' + index"
                  class="row blaLeaderBoardPlayerCard"
                  :class="{ blaLeaderBoardActive: item.isCurrentUser }"
                >
                  <div class="col-3 blaLeaderBoardPosition">
                    {{ item.position }} .
                  </div>
                  <div class="col-5 blaLeaderBoardNickname">
                    {{ item.nickname }}
                  </div>
                  <div class="col-4 blaLeaderBoardScores">
                    {{ item.score_weekly }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="blaLeaderBoardNoData">
                      Még senki sem érte el a SILVER zónát!
                    </div>
                  </div>
                </div>
              </div>
              <!-- SILVER - HR -->
              <div class="row w-100 blaLeaderBoardHR silver">
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
                <div class="col-8 blaLeaderBoardHRText">
                  SILVER ZÓNA <br />
                  75.000 lingron <br />
                  összegyűjtése után
                </div>
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
              </div>

              <!-- BRONZE -->
              <div
                v-if="
                  leaderBoardDatas.datas &&
                  leaderBoardDatas.datas.bronze &&
                  leaderBoardDatas.datas.bronze.length != 0
                "
              >
                <div
                  v-for="(item, index) in leaderBoardDatas.datas.bronze"
                  :key="'gold-' + index"
                  class="row blaLeaderBoardPlayerCard"
                  :class="{ blaLeaderBoardActive: item.isCurrentUser }"
                >
                  <div class="col-3 blaLeaderBoardPosition">
                    {{ item.position }} .
                  </div>
                  <div class="col-5 blaLeaderBoardNickname">
                    {{ item.nickname }}
                  </div>
                  <div class="col-4 blaLeaderBoardScores">
                    {{ item.score_weekly }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="blaLeaderBoardNoData">
                      Még senki sem érte el a BRONZ zónát!
                    </div>
                  </div>
                </div>
              </div>
              <!-- BRONZE - HR -->
              <div class="row w-100 blaLeaderBoardHR bronze">
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
                <div class="col-8 blaLeaderBoardHRText">
                  BRONZ ZÓNA <br />
                  50.000 lingron <br />
                  összegyűjtése után
                </div>
                <div class="col-2 blaLeaderBoardCaretImgContainer">
                  <img
                    :src="require('@/assets/img/caret-arrow-up.png')"
                    class="img-fluid"
                    alt="caret-arrow-up"
                  />
                </div>
              </div>

              <!-- UNDER ZONE -->
              <div
                v-if="
                  leaderBoardDatas.datas &&
                  leaderBoardDatas.datas.under &&
                  leaderBoardDatas.datas.under.length != 0
                "
              >
                <div
                  v-for="(item, index) in leaderBoardDatas.datas.under"
                  :key="'under-' + index"
                  class="row blaLeaderBoardPlayerCard"
                  :class="{ blaLeaderBoardActive: item.isCurrentUser }"
                >
                  <div class="col-3 blaLeaderBoardPosition">
                    {{ item.position }} .
                  </div>
                  <div class="col-5 blaLeaderBoardNickname">
                    {{ item.nickname }}
                  </div>
                  <div class="col-4 blaLeaderBoardScores">
                    {{ item.score_weekly }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-10 offset-1 col-md-8 offset-md-2 mt-4">
      <div class="row align-content-center justify-content-center">
        <div
          class="
            col-10
            offset-1
            col-md-8
            offset-md-2
            blaStepFieldBox
            blaLeaderBoardCounterTitle
            align-content-center
            text-center
          "
        >
          A Te pontszámod:
          <span class="blaLeaderBoardCounter">
            {{ leaderBoardDatas.userPoints }}
          </span>
        </div>
      </div>
    </div>

    <div v-show="showInfoModal" class="blaModal">
      <h2 class="text-purple">Pontszámítás infó</h2>
      <p class="text-justify px-3">
        Szerezz heti arany, ezüst és bronz érmeket sok ismétléssel. Minden lecke
        ismetleséért a következő jutalom jár: <br />
        <br />
        <ul class="list-unstyled font-weight-bold">
            <li>1. ismétlés: elért pontszám </li>
            <li>2. ismétlés: elért pontszám + 1000 pont </li>
            <li>3. ismétlés: elért pontszám + 5000 pont</li>
            <li>4. ismétlés: elért pontszám + 10000 pont</li>
            <li>5. ismetles: elért + 20000 pont</li>
            <li>6. ismétlés: nincs bónusz</li>
        </ul>

      </p>
      <div
        class="blaModalButton blaModalButtonFull"
        @click="showInfoModal = false"
      >
        MÉGSE
      </div>
    </div>
    <div v-show="showInfoModal" class="blaModalBg"></div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Loader from "@/components/partials/Loader";
import { mapGetters } from "vuex";

export default {
  components: { Loader },
  data: () => ({
    showLoader: false,
    leaderBoardDatas: {},
    userData: {},
    currentWeek: null,
    timer: {
      start: null,
      end: null,
    },
    showInfoModal: false,
  }),
  methods: {
    getLeaderBoardData() {
      this.showLoader = true;
      axios
        .post(this.apiUrl + "/api/leaderboard", {
          token: this.token,
        })
        .then((response) => {
          this.leaderBoardDatas = response.data.leaderBoardDatas;
          this.userData = response.data.userData;
          this.currentWeek = response.data.currentWeek;
          this.timer = response.data.timer;

          console.log(this.leaderBoardDatas);

          setTimeout(() => {
            this.showLoader = false;
            this.startTimer();
          }, 1500);
        })
        .catch((error) => {
          this.showLoader = false;
          console.log(error);
        });
    },
    startTimer() {
      const eventTime = this.timer.end;
      const currentTime = this.timer.start;
      const diffTime = eventTime - currentTime;
      let duration = moment.duration(diffTime * 1000, "milliseconds");
      const interval = 1000;
      const countdown = document.getElementById("timer");

      setInterval(() => {
        duration = moment.duration(duration - interval, "milliseconds");

        let hours = duration.hours();
        let minutes = duration.minutes();
        let seconds = duration.seconds();

        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }

        countdown.innerText =
          "Hátralévő idő: " +
          duration.days() +
          " nap " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds;
      }, interval);
    },
  },
  computed: {
    ...mapGetters(["user", "apiUrl", "token"]),
  },
  mounted() {
    this.getLeaderBoardData();
  },
};
</script>

<style>
</style>
